<script>
	import InputItemWithLabel from 'components/input-item-with-label';

	export default {
		props: {
			items: {
				type: Array,
				required: true
			},
			onItemClick: {
				type: Function,
				default: () => {}
			},
			grid: {
				type: Boolean,
				default: false
			},
			legend: {
				type: String
			}
		},
		components: {
			'input-item-with-label': InputItemWithLabel
		}
	};
</script>
<style lang="scss">
	@import 'mixins/global';
	@import 'config/colors';

	.item-selector {
		--item-selector-horizontal-gap: 0.5rem;
		--item-selector-vertical-gap: 1rem;
		--item-selector-individual-width: 5.75rem;

		.items {
			display: flex;
			flex-wrap: wrap;
			gap: var(--item-selector-vertical-gap) var(--item-selector-horizontal-gap);
		}

		.individual-item {
			white-space: nowrap;
			flex-basis: var(--item-selector-individual-width);

			&.span-3 {
				flex-basis: calc(3 * var(--item-selector-individual-width) + 2 * var(--item-selector-horizontal-gap));
			}
		}

		.input-label {
			display: flex;
			justify-content: center;
			align-items: center;
			text-align: center;
			padding: 0.6rem 1.5rem;
			flex-grow: 1;
			color: $c-slate-dark;
			background-color: $c-white;
			border: {
				style: solid;
				color: $c-slate;
				radius: 38px;
				width: 1px;
			}
			transition:
				background-color 0.2s,
				color 0.2s,
				border-color 0.2s;

			[type='checkbox'] {
				@include hidden-visually;
			}

			&:hover,
			&.active {
				color: $c-blue-dark;
				border-color: $c-blue-dark;
				font-weight: 700;
			}

			&.active {
				background-color: $c-babyblue;
			}

			&:focus-within {
				@include focus-outline;
			}
		}

		&.grid {
			--item-selector-horizontal-gap: 0px;
			--item-selector-vertical-gap: 0px;
			--item-selector-individual-width: 1.25rem;
			--item-selector-columns: 12;

			.items {
				display: grid;
				grid-template-columns: repeat(var(--item-selector-columns, 12), minmax(var(--item-selector-individual-width), 1fr));
				border: {
					style: solid;
					width: 1px 0 0 1px;
					color: $c-grey;
				}
			}

			.individual-item {
				grid-column: span 2;

				&.span-1-5 {
					grid-column: span 3;
				}

				&.span-3 {
					grid-column: span 6;
				}
			}

			.input-label {
				padding: 0.25rem;
				border: {
					style: solid;
					width: 0 1px 1px 0;
					color: $c-grey;
					radius: 0;
				}

				&:hover,
				&.active,
				&.active:hover {
					border-color: $c-grey;
				}
			}
		}
	}
</style>
<template>
	<fieldset
		v-if="items"
		class="item-selector"
		:class="{
			grid
		}">
		<legend
			v-if="legend"
			class="item-selector-legend"
			v-text="legend"></legend>
		<div class="items">
			<div
				v-for="item in items"
				:key="item.id"
				class="individual-item"
				:class="item.class">
				<input-item-with-label
					:item="item"
					:on-item-click="onItemClick"
					buffer-text>
				</input-item-with-label>
			</div>
		</div>
	</fieldset>
</template>
